import React from "react";
import { Button } from "basis";
import styled, { css } from "styled-components";
import { COLOR } from "./theme";

const Wrapper = styled.div`
  ${(props) =>
    props.smallFont &&
    css`
      && button {
        font-size: 14px;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
      && button {
        width: 100%;
      }
    `}

  ${(props) =>
    props.hoverColor &&
    css`
      && button:hover {
        cursor: pointer;
        background-color: ${props.hoverColor};

        svg > path {
          fill: ${props.hoverColor};
        }
      }
    `}

  ${(props) =>
    props.showButton
      ? css`
          display: block;
        `
      : css`
          display: none;
        `}

  button {
    cursor: pointer;
  }

    ${(props) =>
      props.customVariant === "secondary" &&
      css`
        && button {
          background-color: ${COLOR.WHITE};
          color: ${COLOR.LATITUDE_BLUE_INDIGO};
          border: 1px solid ${COLOR.LATITUDE_BLUE_INDIGO};
          font-family: "LatitudeSans", sans-serif;
          font-size: 16px;
          font-weight: 600;
          &:hover {
            background-color: ${COLOR.LATITUDE_BLUE_INDIGO};
            color: ${COLOR.WHITE};
          }
          &:disabled {
            background-color: ${COLOR.BUTTON.DISABLED};
            color: ${COLOR.GREY_INACTIVE};
            border: 1px solid ${COLOR.GREY_INACTIVE};
          }
        }
      `}
    ${(props) =>
      props.customVariant === "primary" &&
      css`
        && button {
          background-color: ${COLOR.BUTTON.DEFAULT};
          color: ${COLOR.LATITUDE_BLUE_INDIGO};
          font-family: "LatitudeSans", sans-serif;
          font-size: 16px;
          font-weight: 600;
          &:hover {
            background-color: ${COLOR.BUTTON.HOVER};
            color: ${COLOR.LATITUDE_BLUE_INDIGO};
          }
          &:disabled {
            background-color: ${COLOR.BUTTON.DISABLED};
            color: ${COLOR.GREY_INACTIVE};
            border: 1px solid ${COLOR.GREY_INACTIVE};
          }
        }
      `}

    ${(props) =>
      props.width &&
      css`
        width: ${props.width}px;
        && button {
          width: ${props.width}px;
        }
      `}
`;

export default ({
  showButton,
  smallFont,
  margin,
  fullWidth,
  hoverColor,
  customVariant,
  width,
  ...restProps
}) => {
  const buttonProps = {
    ...restProps,
  };

  return (
    <Wrapper
      showButton={showButton}
      smallFont={smallFont}
      margin={margin}
      fullWidth={fullWidth}
      hoverColor={hoverColor}
      customVariant={customVariant}
      width={width}
    >
      <Button {...buttonProps}></Button>
    </Wrapper>
  );
};
